import { render, staticRenderFns } from "./ObservationsTable.vue?vue&type=template&id=fe9f7660&"
import script from "./ObservationsTable.js?vue&type=script&lang=js&"
export * from "./ObservationsTable.js?vue&type=script&lang=js&"
import style0 from "./ObservationsTable.vue?vue&type=style&index=0&id=fe9f7660&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports